// @ts-ignore
import json2php from 'json2php';
import prettier from 'prettier';
// @ts-ignore
import phpPlugin from '@prettier/plugin-php/standalone';
import {
	ThemeExtensions, LanguageExtensions, Plugins, Keymaps,
} from '@knitiv/code-editor';

export default class ModalQueryPhpController {
	/* @ngInject */
	/**
	 * @param {any} $copyToClipboard
	 * @param {import('angular').IFilterService} $filter
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/query').default} query
	 */
	constructor(
		$copyToClipboard,
		$filter,
		$translate,
		$uibModalInstance,
		query,
	) {
		this.$copyToClipboard = $copyToClipboard;
		this.$filter = $filter;
		this.$translate = $translate;
		this.$uibModalInstance = $uibModalInstance;
		this.query = query;

		const script = `<?php\n\n${json2php(query)};`;
		this.script = prettier.format(script, {
			plugins:     [phpPlugin],
			parser:      'php',
			singleQuote: true,
			useTabs:     true,
			tabWidth:    2,
		});
		this.aceStyles = {
			height: 'calc(100vh - 190px)',
		};
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.php(),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
		];
	}

	close() {
		this.$uibModalInstance.close();
	}

	copyAll() {
		this.$copyToClipboard(
			this.script,
			true,
			(/** @type {string} */ v) => this.$filter('sprintf')(
				this.$translate.instant('common.x-copied-to-clipboard'),
				`<samp>${v.slice(0, 30)}...</samp>`,
			),
		);
	}
}
